import { isMobile } from '../helpers/isMobile';
import { slotBarSymbolNames, slotSpineKey } from './symbolsNames';

// RU: ассеты разложены по платформе одинаково — `.../<web|mobile>/...`, поэтому список один,
//     а платформа — его аргумент.
export const platformFolder = () => (isMobile() ? 'mobile' : 'web');

// RU: спайн — json и atlas с одним путём.
const spineResource = (name, path) => ({
  name,
  path: `${path}.json`,
  config: {
    metadata: {
      spineAtlasFile: `${path}.atlas`,
      imageNamePrefix: '_',
    },
  },
});

// RU: атлас TexturePacker и его KTX2-версия рядом (без транскодера ядро берёт PNG).
const atlasResource = (name, path) => ({
  name,
  path: `${path}.json`,
  ktxPath: `${path}.ktx2`,
  isTPSpriteAtlas: true,
});

// RU: папки спайнов символов по номеру: 1–8 — обычные символы, 9 — wild, 10 и 11 — scatter.
const SYMBOL_FOLDERS = {
  1: 'symbol1',
  2: 'symbol2',
  3: 'symbol3',
  4: 'symbol4',
  5: 'symbol5',
  6: 'symbol6',
  7: 'symbol7',
  8: 'symbol8',
  9: 'wild',
  10: 'scatter1',
  11: 'scatter2',
};

// RU: спайн Big Win назван у платформ по-разному — как в риге.
const WIN_POPUP_FILE = { web: 'winPopupsWeb', mobile: 'winPopupsMobile' };

const GAMBLE_ASSETS = 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture';

const atlases = (gameName, platform) => [
  atlasResource('infoSection', `game/${gameName}/images/${platform}/infoSection`),
  atlasResource('gameImages', `game/${gameName}/images/${platform}/gameImages`),
];

const sceneSpines = (gameName, platform) => [
  ...Object.entries(SYMBOL_FOLDERS).map(([id, folder]) =>
    spineResource(
      slotBarSymbolNames[`icon${id}`],
      `game/${gameName}/slotCharacters/${platform}/${folder}/${folder}`
    )
  ),
  spineResource(slotSpineKey.gameLogo, `game/${gameName}/logo/${platform}/Logo`),
  // RU: спайн фона — ресурс игры: ядро рисует его по `bgConfigs.resourceKey` (по умолчанию
  //     `mainBg`), но не грузит (0bdf1a8c). Риг — `mainBg` frame-пака, папка по платформе.
  spineResource('mainBg', `frame/frameModuleResources/main/mainBg/${platform}/background`),
  spineResource(slotSpineKey.winLine, `game/${gameName}/line/${platform}/line`),
  spineResource(slotSpineKey.winSymbolBorder, `game/${gameName}/winSymbolBorder/${platform}/winFrame`),
  spineResource(slotSpineKey.gambleAmountFrame, `${GAMBLE_ASSETS}/${platform}/amountFrame/amount`),
  spineResource(slotSpineKey.gambleCard, `${GAMBLE_ASSETS}/${platform}/card/card`),
  spineResource(slotSpineKey.gambleSymbol, `${GAMBLE_ASSETS}/${platform}/symbol/symbol`),
  // RU: спайн Big Win ядро рисует, но не грузит — его объявляет игра (MIGRATION-CLASSIC §2.1).
  spineResource(
    slotSpineKey.winPopup,
    `frame/frameModuleResources/main/winPopup/${platform}/${WIN_POPUP_FILE[platform]}`
  ),
];

// RU: bitmap-шрифт суммы Big Win этой игры. Алиас свой (`fontPopup`): `winPopupNumbers` занят
//     frame-паком ядра, и повторная регистрация файл игры не загрузила бы (CORE-CONTRACT §6).
const bitmapFonts = [
  { name: 'fontPopup', path: 'frame/frameModuleResources/main/bitmapFonts/fontWildWeen.xml' },
];

export const gameResources = (gameName) => {
  const platform = platformFolder();
  return [...atlases(gameName, platform), ...sceneSpines(gameName, platform), ...bitmapFonts];
};
